import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./SearchModal.module.css";
import { useLanguage } from "../LanguageContext";

const SearchModal = ({ isOpen, onClose }) => {
    const modalRef = useRef(null);
    const inputRef = useRef(null);
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");
    const { language, textContent } = useLanguage();

    useEffect(() => {
        if (isOpen) {
            // Focus on input when modal opens
            inputRef.current?.focus();
        }
    }, [isOpen]);

    const handleSearch = (e) => {
        if (e.key === "Enter" && searchQuery.trim()) {
            navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
            onClose();
            setSearchQuery("");
        }
    };

    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === "Escape") {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener("keydown", handleEscape);
            document.body.style.overflow = "hidden";
        }

        return () => {
            document.removeEventListener("keydown", handleEscape);
            document.body.style.overflow = "unset";
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    // Helper function to add "էջ" (page) in Armenian
    const formatPageLabel = (translationKey) => {
        const baseLabel = textContent[language][translationKey];
        return language === "ARM" ? `${baseLabel}` : `${baseLabel}`;
    };

    const quickLinks = [
        { label: formatPageLabel("services"), path: "/services" },
        { label: formatPageLabel("news"), path: "/news" },
        { label: formatPageLabel("reports"), path: "/reports" },
        { label: formatPageLabel("careers"), path: "/careers" },
        { label: formatPageLabel("tenders"), path: "/tenders" },
    ];

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()} ref={modalRef}>
                <div className={styles.searchContainer}>
                    <svg className={styles.searchIcon} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12.803 12.803C13.4586 12.1473 13.9787 11.369 14.3335 10.5124C14.6883 9.65577 14.8709 8.73765 14.8709 7.81046C14.8709 6.88327 14.6883 5.96515 14.3335 5.10854C13.9787 4.25192 13.4586 3.47359 12.803 2.81796C12.1473 2.16234 11.369 1.64227 10.5124 1.28745C9.65577 0.932624 8.73765 0.75 7.81046 0.75C6.88327 0.75 5.96515 0.932624 5.10854 1.28745C4.25192 1.64227 3.47359 2.16234 2.81796 2.81796C1.49387 4.14205 0.75 5.93791 0.75 7.81046C0.75 9.68301 1.49387 11.4789 2.81796 12.803C4.14205 14.1271 5.93791 14.8709 7.81046 14.8709C9.68301 14.8709 11.4789 14.1271 12.803 12.803ZM12.803 12.803L17.25 17.25"
                            stroke="#8D8D8D"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>

                    <input
                        ref={inputRef}
                        type="text"
                        className={styles.searchInput}
                        placeholder={language === "ARM" ? "Որոնել arca.am" : "Search arca.am"}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyDown={handleSearch}
                    />
                </div>

                <div className={styles.quickLinksSection}>
                    <p className={styles.quickLinksTitle}>{language === "ARM" ? "Արագ հղումներ" : "Quick links"}</p>
                    <div className={styles.linksList}>
                        {quickLinks.map((link, index) => (
                            <Link key={index} to={link.path} className={styles.quickLink} onClick={onClose}>
                                <span>{link.label}</span>
                                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6.5 12.5L12.5 6.5M12.5 6.5L6.5 0.5M12.5 6.5L0.5 6.5"
                                        stroke="black"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchModal;
